export default __webpack_public_path__ + "static/media/iGrow.7cdc0d3d.png";